<template>
    <v-container>
        <v-card class="blue-grey lighten-5 elevation-4">
            <v-toolbar dense flat color="blue-grey darken-2" dark>
                <v-toolbar-title>Dekklagring</v-toolbar-title>
                <v-spacer/>
                <v-menu>
                    <template v-slot:activator="{ on }">
                        <v-btn text v-on="on">
                            <v-icon left>print</v-icon>
                            Skriv ut
                        </v-btn>
                    </template>

                    <v-list>
                        <v-list-item :href="`/print/storage/${storageId}`" tag="a" target="_blank">
                            <v-list-item-content>
                                <v-list-item-title>Skriv ut ordre</v-list-item-title>
                            </v-list-item-content>
                        </v-list-item>
                        <v-list-item :href="`/print/tires/${storageId}`" tag="a" target="_blank">
                            <v-list-item-content>
                                <v-list-item-title>Skriv ut merkelapper</v-list-item-title>
                            </v-list-item-content>
                        </v-list-item>
                        <v-list-item :href="`/print/storage/${storageId}/delivery`" tag="a" target="_blank">
                            <v-list-item-content>
                                <v-list-item-title>Skriv ut levering</v-list-item-title>
                            </v-list-item-content>
                        </v-list-item>
                    </v-list>
                </v-menu>
            </v-toolbar>
            <v-card-text class="pa-2">
                <tire-storage-form :car-id="carId" :storage-id="storageId" :storage="base" @save="onSave"/>
            </v-card-text>
        </v-card>
    </v-container>
</template>

<script>
    import TireStorageForm from '../helpers/TireStorageForm';

    export default {
        components: {
            TireStorageForm
        },

        methods: {
            onSave(storage) {
                let historyComponent = this.$parent.$refs.history;
                if (historyComponent) historyComponent.loadData();

                let changelogComponent = this.$parent.$refs.changelog;
                if (changelogComponent) changelogComponent.loadData();

                let invoicesComponent = this.$parent.$refs.invoices;
                if (invoicesComponent) invoicesComponent.loadData();
                return this.$router.push({
                    name: 'TireStorage',
                    params: {
                        id: this.carId,
                        storage: storage.id
                    }
                });
            }
        },

        computed: {
            carId() {
                return parseInt(this.$route.params.id);
            },
            storageId() {
                let id = this.$route.params.storage;
                return id ? parseInt(id) : null;
            },
            base() {
                // Base storage when copying existing storage.
                return this.$route.params.base;
            }
        }
    }
</script>
